import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.logistics-vehicle')
  .factory('$logisticsVehicle', logisticsVehicleObjectFactory);

/* @ngInject */
function logisticsVehicleObjectFactory($bringozFactory: $bringozFactory,
                                       LogisticsVehicleAPI: BringozApi,
                                       LogisticsVehicles_DS: DataStoreConfig) {

  function $logisticsVehicle(id: string) {
    return $bringozFactory(id, LogisticsVehicleAPI, LogisticsVehicles_DS)
  }
  return $logisticsVehicle
}
